export enum AWSChallenge {
    MultiFactorSMS = "SMS_MFA",
    MultiFactorToken = "SOFTWARE_TOKEN_MFA",
    MultiFactorSelection = "SELECT_MFA_TYPE",
    MultiFactorSetup = "MFA_SETUP",
    PasswordVerification = "PASSWORD_VERIFIER",
    CustomChallenge = "CUSTOM_CHALLENGE",
    DeviceTrackingAuthorization = "DEVICE_SRP_AUTH",
    DevicePasswordVerification = "DEVICE_PASSWORD_VERIFIER",
    AdminNoSRPAuthentication = "ADMIN_NO_SRP_AUTH", // Secure Remote Password
    NewPasswordRequired = "NEW_PASSWORD_REQUIRED"
}